module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__bottom__buttons__a--swap-1847a68811ce5e07e9853aa7ddaddebb.svg";